module.exports = __webpack_public_path__ + "static/Canva-85c36ada95b8d070183a8a9a36ef4805.jpg";